import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { defineIntegration, convertIntegrationFnToClass } from '@sentry/core';
import { WINDOW } from '../helpers.js';
var INTEGRATION_NAME = 'HttpContext';

var _httpContextIntegration = function _httpContextIntegration() {
  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce: function setupOnce() {},
    // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent: function preprocessEvent(event) {
      // if none of the information we want exists, don't bother
      if (!WINDOW.navigator && !WINDOW.location && !WINDOW.document) {
        return;
      } // grab as much info as exists and add it to the event


      var url = event.request && event.request.url || WINDOW.location && WINDOW.location.href;

      var _ref = WINDOW.document || {},
          referrer = _ref.referrer;

      var _ref2 = WINDOW.navigator || {},
          userAgent = _ref2.userAgent;

      var headers = _objectSpread(_objectSpread(_objectSpread({}, event.request && event.request.headers), referrer && {
        Referer: referrer
      }), userAgent && {
        'User-Agent': userAgent
      });

      var request = _objectSpread(_objectSpread(_objectSpread({}, event.request), url && {
        url: url
      }), {}, {
        headers: headers
      });

      event.request = request;
    }
  };
};

var httpContextIntegration = defineIntegration(_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation

var HttpContext = convertIntegrationFnToClass(INTEGRATION_NAME, httpContextIntegration);
export { HttpContext, httpContextIntegration };